require('jqmask');

$.validator.addMethod(
    'mobileValidation',
    (value, element) => {
      if ($(element).hasClass('required') === false) {
        return true;
      }

      if (value === undefined || value === null || value === '') {
        return false;
      }
      return (/^[0-9]{10}$/).test(value);
    }
);

$(() => {
  $("[data-id='mobile'], [data-id='tel']").mask('9999999999', { placeholder: '' });
  $("[data-id='zip']").mask('9999', { placeholder: '' });
});

$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (OCMS.GlobalVars.Brand === 'occ' && form !== undefined && form !== null && form.id === 'shipping') {
    const BelgiumSpecificConfigureShippingMethod = () => {
      const list = $("[data-id='shippingMethodList']");
      list.find('.rdblistShippingMethodStep3 input').attr('disabled', true);
      list.find('.rdblistShippingMethodStep3 input').attr('checked', false);
      list.find('.rdblistShippingMethodStep3').each(() => {
        const $span = $(this);
        const title = $span.attr('data-title').toLowerCase();
        const country = form.country().toLowerCase();
        if ((title.indexOf(country) >= 0 || country === 'belgique') && (title.indexOf('belgië') >= 0 || country === 'belgië') && (title.indexOf('belgique') >= 0 || country === 'belgium') && (title.indexOf('belgique') || country === 'belgium') && title.indexOf('belgië')) {
          $span.find('input').attr('disabled', false);
        }
      });
      list.find('.rdblistShippingMethodStep3 input:radio').trigger('change');
    };

    BelgiumSpecificConfigureShippingMethod();
    form.countryField.on('change', BelgiumSpecificConfigureShippingMethod);
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/belgium.form.js